export const ObjBoolean = [
    {
      id: 1,
      label: 'SIM',
    },
    {
      id: 2,
      label: 'NÃO'
    }
  ]

export const tiposDeImplantacao = [
    {
      id: 1,
      label: 'Implantação Parcial'
    }, {
      id: 2,
      label: 'Implantação Total'
    }
  ]

 export const nivelHierarquico = [
    {
      id: 1,
      label: 'CEO'
    }, {
      id: 2,
      label: 'Vice Presidente'
    }, {
      id: 3,
      label: 'Diretor'
    }, {
      id: 4,
      label: 'Gerente'
    }, {
      id: 5,
      label: 'Coordenador'
    }, {
      id: 6,
      label: 'Engenheiro'
    },
  ]

  export const tagsRel ={
    headers:[
        { key: "cnpj", label: "CNPJ"},
        { key: "empresa", label: "Empresa"},
        { key: "ano", label: "Ano"},
        { key: "fezAdesaoProx", label: "A empresa já fez a adesão da utilização do aplicativo PROX?"},
        { key: "planejaAdesaoProx", label: "A empresa planeja fazer a adesão do aplicativo PROX?"},
        { key: "quandoPlanejaAdesaoProx", label: "Quando sua empresa planeja fazer a adesão do aplicativo PROX?"},
        { key: "planejamentoGestaoRejeitos", label: "A empresa tem planejamento para implementar o Padrão Global da Indústria para Gestão de Rejeitos em suas operações?"},
        { key: "tipoDeImplantacao", label: "Qual tipo de implantação pretende fazer?"},
        { key: "prevInicioImplantacao", label: "Previsão para início da implantação"},
        { key: "prevFinalizacaoImplantacao", label: "Previsão para a finalização da implantação"},
        { key: "mediaParaEstruturas", label: "Percepção de aderência da empresa em relação aos tópicos abordados no Padrão Global da Indústria para Gestão de Rejeitos (média para todas as estruturas em %)"},
        { key: "tipoGapAssessment", label: "Tipo “gap assessment”?"},
        { key: "definiuExecutivoResp", label: "A empresa já definiu quem será o Executivo Responsável?"},
        { key: "nivelHierarquicoProfissional", label: "Qual o nível hierárquico desse profissional"},
        { key: "implementouCirrItrb", label: "Implementou o Conselho Independente de Gestão de Rejeitos (CIRR ou ITRB)?"},
        { key: "prevFinalizacaoImplementacao", label: "Previsão para a finalização da implementação"},
        { key: "observacoes", label: "Observações"},
        { key: "createdAt", label: "Inserido"},
        { key: "updatedAt", label: "Atualizado"},

    ]
}